<template>
    <div class="dhivehi">
        <div :id="rootId" :style="`height: ${height ? height+'px': '500px'}`"></div>
    </div>
</template>

<script>
import am5 from './am5'
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

export default {
    props: [
        'showLegend', 
        'title', 
        'height', 
        'labels', 
        'percent', 
        'mainColor', 
        'accentColor',
        'percent_label_size'
    ],
    data() {return {
        rootId: null,
        root: null
    }},
    watch: {
        percent(){
            this.root?.dispose()
            this.root = am5.Root.new(this.rootId)
            this.draw()
        }
    },
    methods: {
        draw(){
            this.root.setThemes([
                am5themes_Animated.new(this.root)
            ]);

            let chart = this.root.container.children.push( 
                am5percent.PieChart.new(this.root, {
                    layout: this.root.verticalLayout,
                    radius: am5.percent(95),
                    innerRadius: am5.percent(85),
                }) 
            );

            if(this.title){
                let label = chart.children.push(am5.Label.new(this.root, {
                    text: this.title,
                    fontSize: 12,
                    textAlign: "center",
                    //fontFamily: "MV Typewriter",
                    // fontWeight: 'bold',
                    fill: '#777',
                    width: am5.p100,
                    visible: true
                }));
            }


            // Create series
            let series = chart.series.push(
                am5percent.PieSeries.new(this.root, {
                    name: "Series",
                    valueField: "count",
                    categoryField: "label",
                })
            );

            // percent label
            series.children.push(am5.Label.new(this.root, {
                text: this.percent+'%',
                // fontSize: 20,
                fontSize: this.percent_label_size ? this.percent_label_size : 20,
                // fontWeight: 'bold',
                centerX: am5.percent(50),
                centerY: am5.percent(50)
            }))

            if(this.labels === true) {
                series.labels.template.setAll({
                    // direction: "rtl",
                    textAlign: "center",
                    maxWidth: 250,
                    oversizedBehavior: 'wrap',
                    text: " [fontWeight: 'bold';fontSize:'16pt';]{value}[/]\n{category}\n{valuePercentTotal.formatNumber('#.#')}%"
                })
                series.ticks.template.setAll({
                    stroke: '#333',
                    strokeWidth: 1.5,
                    location: 0.9,
                });
            }
            else {
                series.labels.template.set("visible", false)
                series.ticks.template.set("visible", false)
            } 

            series.set("tooltipHTML", "<span>{category}: {value} (%{valuePercentTotal.formatNumber('#.#')})</span>");

            // let color = am5.Color.fromString('#4c4')
            // let lighter = am5.Color.lighten(color, 25)
            let d = [
                {
                    count: this.percent,
                    label: 'a',
                    color: this.mainColor ?? '#4c4'
                },
                {
                    count: 100 - this.percent,
                    label: 'b',
                    color: this.accentColor ?? '#afa'
                }
            ]

            series.get("colors").set("colors", d.map(i => i.color));
            series.data.setAll(d);

            if(this.showLegend === true){
                let legend = chart.children.push(am5.Legend.new(this.root, {
                    centerX: am5.percent(100),
                    x: am5.percent(100),
                    layout: this.root.verticalLayout,
                }));

                legend.labels.template.setAll({
                    width: 10,
                    // direction: 'rtl',
                    textAlign: 'start',
                    // fontFamily: 'MV Typewriter'
                });


                legend.valueLabels.template.setAll({
                    // forceHidden: true,
                    width: 300,
                });

                legend.itemContainers.template.setAll({
                    reverseChildren: true
                });

                legend.data.setAll(series.dataItems);
            }

            // let total = data.reduce((sum, {count}) => sum+count, 0)
            // let totalLabel = chart.children.push(am5.Label.new(this.root, {
            //     text: `[bold]${total}[/]ޖުމްލަ: `,
            //     fontSize: '18pt',
            //     textAlign: "center",
            //     fontFamily: "MV Typewriter",
            //     width: am5.p100,
            //     visible: true
            // }));

            chart.appear(1000, 100)
        },

        randomString() {
            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
            let result = "";
            for (let i = 0; i < 10; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        }
    },

    mounted(){
        this.root = am5.Root.new(this.rootId);
        this.draw()
    },

    created(){
        this.rootId = am5.randomString()
    }
}
</script>


<style scoped>

</style>